import React from 'react';
import styled from 'styled-components';

const TitlePage: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default TitlePage;

const Container = styled.div`
  color: #00b1f1;
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  .box {
    display: flex;
    justify-content: space-between;
    button {
      color: #00b1f1;
      background-color: transparent;
      border-color: #00b1f1;
      font-size: 14px;
      margin-left: 1rem;
    }
  }

  @media (max-width: 768px) {
    font-size: 14px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .box button {
      font-size: 12px;
    }
  }
`;
